import React, { Component } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast } from "react-toastify";
import LOCATION_TYPE from "../enum/location_type";

const ITEM_HEIGHT = 48;

class VerticalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = { ...this.props.state, deleteDialogOpen: false }
  }

  handleContextClick = (event, id) => {
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget, selectedRowId: id });
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    let manage_location_name = '';
    if (selectedObject.location_type_id === LOCATION_TYPE.Kiosk) {
      manage_location_name = "Kiosk";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Curbside) {
      manage_location_name = "Curbside";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Counter) {
      manage_location_name = "Counter";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Courier) {
      manage_location_name = "Courier";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Other) {
      manage_location_name = "Other";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Bedside) {
      manage_location_name = "Bedside";
    }
    if (selectedObject) {
      const filteredObject = {
        manage_location_name: manage_location_name,
        selectedTab: 0,
        showNewBoxDialog: true,
        operation: "View",
        location_notes: selectedObject.location_notes,
        selectCourierType:
          selectedObject.courier_type && selectedObject.courier_type.length > 0
            ? selectedObject.courier_type[0].split(",")
            : [],
        name:
          selectedObject.name === "" ||
            selectedObject.name === "null" ||
            selectedObject.name === null ||
            selectedObject.name === undefined ||
            selectedObject.name === "undefined"
            ? ""
            : selectedObject.name,
        parent_id: selectedObject.parent_account_id,
        description:
          selectedObject.description === "" ||
            selectedObject.description === "null" ||
            selectedObject.description === null ||
            selectedObject.description === undefined
            ? ""
            : selectedObject.description,
        type_id:
          selectedObject.type && selectedObject.type.id
            ? selectedObject.type.id
            : null,
        avatarPreview: selectedObject.picture_url,
        address1:
          selectedObject.address &&
            (selectedObject.address.address_line_1 === "" ||
              selectedObject.address.address_line_1 === "null" ||
              selectedObject.address.address_line_1 === null ||
              selectedObject.address.address_line_1 === undefined ||
              selectedObject.address.address_line_1 === "undefined")
            ? ""
            : selectedObject.address.address_line_1,
        address2:
          selectedObject.address &&
            (selectedObject.address.address_line_2 === "" ||
              selectedObject.address.address_line_2 === "null" ||
              selectedObject.address.address_line_2 === null ||
              selectedObject.address.address_line_2 === undefined ||
              selectedObject.address.address_line_2 === "undefined")
            ? ""
            : selectedObject.address.address_line_2,
        zip:
          selectedObject.address &&
            (selectedObject.address.zip === "" ||
              selectedObject.address.zip === "null" ||
              selectedObject.address.zip === null ||
              selectedObject.address.zip === undefined ||
              selectedObject.address.zip === "undefined")
            ? ""
            : selectedObject.address.zip,
        state:
          selectedObject.address &&
            (selectedObject.address.state === "" ||
              selectedObject.address.state === "null" ||
              selectedObject.address.state === null ||
              selectedObject.address.state === undefined ||
              selectedObject.address.state === "undefined")
            ? ""
            : selectedObject.address.state,
        city:
          selectedObject.address &&
            (selectedObject.address.city === "" ||
              selectedObject.address.city === "null" ||
              selectedObject.address.city === null ||
              selectedObject.address.city === undefined ||
              selectedObject.address.city === "undefined")
            ? ""
            : selectedObject.address.city,
        status:
          selectedObject.boxstatus &&
            (selectedObject.boxstatus === "" ||
              selectedObject.boxstatus === "null" ||
              selectedObject.boxstatus === null ||
              selectedObject.boxstatus === undefined ||
              selectedObject.boxstatus === "undefined")
            ? ""
            : selectedObject.boxstatus,
        kiosk_box_id:
          selectedObject.kiosk_box_id === "null" ||
            selectedObject.kiosk_box_id === null ||
            selectedObject.kiosk_box_id === undefined ||
            selectedObject.kiosk_box_id === "undefined"
            ? ""
            : selectedObject.kiosk_box_id,
        IsActive:
          selectedObject.IsActive !== "" &&
            selectedObject.IsActive !== "null" &&
            selectedObject.IsActive !== null &&
            selectedObject.IsActive !== undefined &&
            selectedObject.IsActive !== "undefined"
            ? selectedObject.IsActive
            : "",
        Sun:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_sunday === "" ||
            selectedObject.hoursof_operations.is_sunday === "null" ||
            selectedObject.hoursof_operations.is_sunday === null ||
            selectedObject.hoursof_operations.is_sunday === undefined ||
            selectedObject.hoursof_operations.is_sunday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_sunday,
        Mon:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_monday === "" ||
            selectedObject.hoursof_operations.is_monday === "null" ||
            selectedObject.hoursof_operations.is_monday === null ||
            selectedObject.hoursof_operations.is_monday === undefined ||
            selectedObject.hoursof_operations.is_monday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_monday,
        Tue:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_tuesday === "" ||
            selectedObject.hoursof_operations.is_tuesday === "null" ||
            selectedObject.hoursof_operations.is_tuesday === null ||
            selectedObject.hoursof_operations.is_tuesday === undefined ||
            selectedObject.hoursof_operations.is_tuesday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_tuesday,
        Wed:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_wednesday === "" ||
            selectedObject.hoursof_operations.is_wednesday === "null" ||
            selectedObject.hoursof_operations.is_wednesday === null ||
            selectedObject.hoursof_operations.is_wednesday === undefined ||
            selectedObject.hoursof_operations.is_wednesday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_wednesday,
        Thu:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_thursday === "" ||
            selectedObject.hoursof_operations.is_thursday === "null" ||
            selectedObject.hoursof_operations.is_thursday === null ||
            selectedObject.hoursof_operations.is_thursday === undefined ||
            selectedObject.hoursof_operations.is_thursday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_thursday,
        Fri:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_friday === "" ||
            selectedObject.hoursof_operations.is_friday === "null" ||
            selectedObject.hoursof_operations.is_friday === null ||
            selectedObject.hoursof_operations.is_friday === undefined ||
            selectedObject.hoursof_operations.is_friday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_friday,
        Sat:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.is_saturday === "" ||
            selectedObject.hoursof_operations.is_saturday === "null" ||
            selectedObject.hoursof_operations.is_saturday === null ||
            selectedObject.hoursof_operations.is_saturday === undefined ||
            selectedObject.hoursof_operations.is_saturday === "undefined"
            ? ""
            : selectedObject.hoursof_operations.is_saturday,
        opentime:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.open_time === "" ||
            selectedObject.hoursof_operations.open_time === "null" ||
            selectedObject.hoursof_operations.open_time === null ||
            selectedObject.hoursof_operations.open_time === undefined ||
            selectedObject.hoursof_operations.open_time === "undefined"
            ? ""
            : selectedObject.hoursof_operations.open_time,
        closetime:
          selectedObject.hoursof_operations === null ||
            selectedObject.hoursof_operations === "" ||
            selectedObject.hoursof_operations === "null" ||
            selectedObject.hoursof_operations.close_time === "" ||
            selectedObject.hoursof_operations.close_time === "null" ||
            selectedObject.hoursof_operations.close_time === null ||
            selectedObject.hoursof_operations.close_time === undefined ||
            selectedObject.hoursof_operations.close_time === "undefined"
            ? ""
            : selectedObject.hoursof_operations.close_time,
        XWebId:
          selectedObject.xwebid === null ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === "" ||
            selectedObject.xwebid === "null" ||
            selectedObject.xwebid === null ||
            selectedObject.xwebid === undefined ||
            selectedObject.xwebid === "undefined"
            ? ""
            : selectedObject.xwebid,
        XWebAuthKey:
          selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === "" ||
            selectedObject.xwebauthkey === "null" ||
            selectedObject.xwebauthkey === null ||
            selectedObject.xwebauthkey === undefined ||
            selectedObject.xwebauthkey === "undefined"
            ? ""
            : selectedObject.xwebauthkey,
        XWebTerminalId:
          selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === "" ||
            selectedObject.xwebterminalid === "null" ||
            selectedObject.xwebterminalid === null ||
            selectedObject.xwebterminalid === undefined ||
            selectedObject.xwebterminalid === "undefined"
            ? ""
            : selectedObject.xwebterminalid,
        addonUnits: selectedObject && selectedObject.box_expansions,
        is_marketplace:
          selectedObject.is_marketplace !== "" &&
            selectedObject.is_marketplace !== "null" &&
            selectedObject.is_marketplace !== null &&
            selectedObject.is_marketplace !== undefined &&
            selectedObject.is_marketplace !== "undefined"
            ? selectedObject.is_marketplace
            : "",
        simpleOrExpressUI: !selectedObject.simple_start,
        express_ui:
          selectedObject.express_ui !== "" &&
          selectedObject.express_ui !== "null" &&
          selectedObject.express_ui !== null &&
          selectedObject.express_ui !== undefined &&
          selectedObject.express_ui !== "undefined" &&
          selectedObject.express_ui &&
          true,
        SimplifiedEnrollment:
          selectedObject.simplified_enrollment !== "" &&
            selectedObject.simplified_enrollment !== "null" &&
            selectedObject.simplified_enrollment !== null &&
            selectedObject.simplified_enrollment !== undefined &&
            selectedObject.simplified_enrollment !== "undefined"
            ? selectedObject.simplified_enrollment
            : "",
        serial_number:
          selectedObject.serial_number === null ||
            selectedObject.serial_number === "" ||
            selectedObject.serial_number === "null" ||
            selectedObject.serial_number === "" ||
            selectedObject.serial_number === "null" ||
            selectedObject.serial_number === null ||
            selectedObject.serial_number === undefined ||
            selectedObject.serial_number === "undefined"
            ? ""
            : selectedObject.serial_number,
        paymentType:
          selectedObject.selected_payment_gateway === null ||
            selectedObject.selected_payment_gateway === "" ||
            selectedObject.selected_payment_gateway === "null" ||
            selectedObject.selected_payment_gateway === "" ||
            selectedObject.selected_payment_gateway === "null" ||
            selectedObject.selected_payment_gateway === null ||
            selectedObject.selected_payment_gateway === undefined ||
            selectedObject.selected_payment_gateway === "undefined"
            ? ""
            : selectedObject.selected_payment_gateway,
        selected_regioin:
          selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === "" ||
            selectedObject.selected_regioin === "null" ||
            selectedObject.selected_regioin === null ||
            selectedObject.selected_regioin === undefined ||
            selectedObject.selected_regioin === "undefined"
            ? ""
            : selectedObject.selected_regioin,
        preferLanguage: selectedObject && selectedObject.preferred_language,
        door_open_debounce_interval:
          selectedObject && selectedObject.door_open_debounce_interval,
        door_interval_between_two_bins:
          selectedObject && selectedObject.door_interval_between_two_bins,
        boxTypeId: selectedObject && selectedObject.type_id,
        allow_multi_bins_pickup:
          selectedObject && selectedObject.allow_multi_bins_pickup,
        openpath: selectedObject.openpath,
        payroll_deduct: selectedObject && selectedObject.payroll_deduct,
        is_kiosk_log: selectedObject && selectedObject.is_kiosk_log,
        openPathUser: selectedObject && selectedObject.openpathuser,
      };
      this.props.retrieveData(filteredObject)
    }
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    let manage_location_name = '';
    if (selectedObject.location_type_id === LOCATION_TYPE.Kiosk) {
      manage_location_name = "Kiosk";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Curbside) {
      manage_location_name = "Curbside";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Counter) {
      manage_location_name = "Counter";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Courier) {
      manage_location_name = "Courier";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Other) {
      manage_location_name = "Other";
    } else if (selectedObject.location_type_id === LOCATION_TYPE.Bedside) {
      manage_location_name = "Bedside";
    }
    const filteredObject = {
      manage_location_name: manage_location_name,
      selectedTab: 0,
      showNewBoxDialog: true,
      operation: "Edit",
      box: selectedObject,
      selectedRadio:
        selectedObject.courier_type && selectedObject.courier_type.length > 0
          ? selectedObject.courier_type[0].default_courier_type
          : [],
      selectCourierType:
        selectedObject.courier_type && selectedObject.courier_type.length > 0
          ? selectedObject.courier_type.map((val) => {
            return val.courier_type;
          })
          : [],
      location_notes: selectedObject.location_notes,
      name:
        selectedObject.name === null ||
          selectedObject.name === "null" ||
          selectedObject.name === "" ||
          selectedObject.name === undefined ||
          selectedObject.name === "undefined"
          ? ""
          : selectedObject.name,
      parent_id: selectedObject.parent_account_id,
      description:
        selectedObject.description === "" ||
          selectedObject.description === "null" ||
          selectedObject.description === null ||
          selectedObject.description === undefined
          ? ""
          : selectedObject.description,
      type_id:
        selectedObject.type && selectedObject.type.id
          ? selectedObject.type.id
          : null,
      avatarPreview: selectedObject.picture_url,
      address1:
        selectedObject.address &&
          (selectedObject.address.address_line_1 === "" ||
            selectedObject.address.address_line_1 === "null" ||
            selectedObject.address.address_line_1 === null ||
            selectedObject.address.address_line_1 === undefined ||
            selectedObject.address.address_line_1 === "undefined")
          ? ""
          : selectedObject.address.address_line_1,
      address2:
        selectedObject.address &&
          (selectedObject.address.address_line_2 === "" ||
            selectedObject.address.address_line_2 === "null" ||
            selectedObject.address.address_line_2 === null ||
            selectedObject.address.address_line_2 === undefined ||
            selectedObject.address.address_line_2 === "undefined")
          ? ""
          : selectedObject.address.address_line_2,
      zip:
        selectedObject.address &&
          (selectedObject.address.zip === "" ||
            selectedObject.address.zip === "null" ||
            selectedObject.address.zip === null ||
            selectedObject.address.zip === undefined ||
            selectedObject.address.zip === "undefined")
          ? ""
          : selectedObject.address.zip,
      state:
        selectedObject.address &&
          (selectedObject.address.state === "" ||
            selectedObject.address.state === "null" ||
            selectedObject.address.state === null ||
            selectedObject.address.state === undefined ||
            selectedObject.address.state === "undefined")
          ? ""
          : selectedObject.address.state,
      city:
        selectedObject.address &&
          (selectedObject.address.city === "" ||
            selectedObject.address.city === "null" ||
            selectedObject.address.city === null ||
            selectedObject.address.city === undefined ||
            selectedObject.address.city === "undefined")
          ? ""
          : selectedObject.address.city,
      status:
        selectedObject.boxstatus &&
          (selectedObject.boxstatus === "" ||
            selectedObject.boxstatus === "null" ||
            selectedObject.boxstatus === null ||
            selectedObject.boxstatus === undefined ||
            selectedObject.boxstatus === "undefined")
          ? ""
          : selectedObject.boxstatus,
      kiosk_box_id:
        selectedObject.kiosk_box_id === "null" ||
          selectedObject.kiosk_box_id === null ||
          selectedObject.kiosk_box_id === undefined ||
          selectedObject.kiosk_box_id === "undefined"
          ? ""
          : selectedObject.kiosk_box_id,
      IsActive:
        selectedObject.IsActive !== "" &&
          selectedObject.IsActive !== "null" &&
          selectedObject.IsActive !== null &&
          selectedObject.IsActive !== undefined &&
          selectedObject.IsActive !== "undefined"
          ? selectedObject.IsActive
          : "",
      Sun:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_sunday === "" ||
          selectedObject.hoursof_operations.is_sunday === "null" ||
          selectedObject.hoursof_operations.is_sunday === null ||
          selectedObject.hoursof_operations.is_sunday === undefined ||
          selectedObject.hoursof_operations.is_sunday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_sunday,
      Mon:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_monday === "" ||
          selectedObject.hoursof_operations.is_monday === "null" ||
          selectedObject.hoursof_operations.is_monday === null ||
          selectedObject.hoursof_operations.is_monday === undefined ||
          selectedObject.hoursof_operations.is_monday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_monday,
      Tue:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_tuesday === "" ||
          selectedObject.hoursof_operations.is_tuesday === "null" ||
          selectedObject.hoursof_operations.is_tuesday === null ||
          selectedObject.hoursof_operations.is_tuesday === undefined ||
          selectedObject.hoursof_operations.is_tuesday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_tuesday,
      Wed:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_wednesday === "" ||
          selectedObject.hoursof_operations.is_wednesday === "null" ||
          selectedObject.hoursof_operations.is_wednesday === null ||
          selectedObject.hoursof_operations.is_wednesday === undefined ||
          selectedObject.hoursof_operations.is_wednesday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_wednesday,
      Thu:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_thursday === "" ||
          selectedObject.hoursof_operations.is_thursday === "null" ||
          selectedObject.hoursof_operations.is_thursday === null ||
          selectedObject.hoursof_operations.is_thursday === undefined ||
          selectedObject.hoursof_operations.is_thursday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_thursday,
      Fri:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_friday === "" ||
          selectedObject.hoursof_operations.is_friday === "null" ||
          selectedObject.hoursof_operations.is_friday === null ||
          selectedObject.hoursof_operations.is_friday === undefined ||
          selectedObject.hoursof_operations.is_friday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_friday,
      Sat:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.is_saturday === "" ||
          selectedObject.hoursof_operations.is_saturday === "null" ||
          selectedObject.hoursof_operations.is_saturday === null ||
          selectedObject.hoursof_operations.is_saturday === undefined ||
          selectedObject.hoursof_operations.is_saturday === "undefined"
          ? ""
          : selectedObject.hoursof_operations.is_saturday,
      opentime:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.open_time === "" ||
          selectedObject.hoursof_operations.open_time === "null" ||
          selectedObject.hoursof_operations.open_time === null ||
          selectedObject.hoursof_operations.open_time === undefined ||
          selectedObject.hoursof_operations.open_time === "undefined"
          ? ""
          : selectedObject.hoursof_operations.open_time,
      closetime:
        selectedObject.hoursof_operations === null ||
          selectedObject.hoursof_operations === "" ||
          selectedObject.hoursof_operations === "null" ||
          selectedObject.hoursof_operations.close_time === "" ||
          selectedObject.hoursof_operations.close_time === "null" ||
          selectedObject.hoursof_operations.close_time === null ||
          selectedObject.hoursof_operations.close_time === undefined ||
          selectedObject.hoursof_operations.close_time === "undefined"
          ? ""
          : selectedObject.hoursof_operations.close_time,
      XWebId:
        selectedObject.xwebid === null ||
          selectedObject.xwebid === "" ||
          selectedObject.xwebid === "null" ||
          selectedObject.xwebid === "" ||
          selectedObject.xwebid === "null" ||
          selectedObject.xwebid === null ||
          selectedObject.xwebid === undefined ||
          selectedObject.xwebid === "undefined"
          ? ""
          : selectedObject.xwebid,
      XWebAuthKey:
        selectedObject.xwebauthkey === null ||
          selectedObject.xwebauthkey === "" ||
          selectedObject.xwebauthkey === "null" ||
          selectedObject.xwebauthkey === "" ||
          selectedObject.xwebauthkey === "null" ||
          selectedObject.xwebauthkey === null ||
          selectedObject.xwebauthkey === undefined ||
          selectedObject.xwebauthkey === "undefined"
          ? ""
          : selectedObject.xwebauthkey,
      XWebTerminalId:
        selectedObject.xwebterminalid === null ||
          selectedObject.xwebterminalid === "" ||
          selectedObject.xwebterminalid === "null" ||
          selectedObject.xwebterminalid === "" ||
          selectedObject.xwebterminalid === "null" ||
          selectedObject.xwebterminalid === null ||
          selectedObject.xwebterminalid === undefined ||
          selectedObject.xwebterminalid === "undefined"
          ? ""
          : selectedObject.xwebterminalid,
      addonUnits: selectedObject && selectedObject.box_expansions,
      is_marketplace:
        selectedObject.is_marketplace !== "" &&
          selectedObject.is_marketplace !== "null" &&
          selectedObject.is_marketplace !== null &&
          selectedObject.is_marketplace !== undefined &&
          selectedObject.is_marketplace !== "undefined"
          ? selectedObject.is_marketplace
          : "",
      simpleOrExpressUI: !selectedObject.simple_start,
      SimplifiedEnrollment:
        selectedObject.simplified_enrollment !== "" &&
          selectedObject.simplified_enrollment !== "null" &&
          selectedObject.simplified_enrollment !== null &&
          selectedObject.simplified_enrollment !== undefined &&
          selectedObject.simplified_enrollment !== "undefined"
          ? selectedObject.simplified_enrollment
          : "",
      serial_number:
        selectedObject.serial_number === null ||
          selectedObject.serial_number === "" ||
          selectedObject.serial_number === "null" ||
          selectedObject.serial_number === "" ||
          selectedObject.serial_number === "null" ||
          selectedObject.serial_number === null ||
          selectedObject.serial_number === undefined ||
          selectedObject.serial_number === "undefined"
          ? ""
          : selectedObject.serial_number,
      paymentType:
        selectedObject.selected_payment_gateway === null ||
          selectedObject.selected_payment_gateway === "" ||
          selectedObject.selected_payment_gateway === "null" ||
          selectedObject.selected_payment_gateway === "" ||
          selectedObject.selected_payment_gateway === "null" ||
          selectedObject.selected_payment_gateway === null ||
          selectedObject.selected_payment_gateway === undefined ||
          selectedObject.selected_payment_gateway === "undefined"
          ? ""
          : selectedObject.selected_payment_gateway,
      selected_regioin:
        selectedObject.selected_regioin === null ||
          selectedObject.selected_regioin === "" ||
          selectedObject.selected_regioin === "null" ||
          selectedObject.selected_regioin === "" ||
          selectedObject.selected_regioin === "null" ||
          selectedObject.selected_regioin === null ||
          selectedObject.selected_regioin === undefined ||
          selectedObject.selected_regioin === "undefined"
          ? ""
          : selectedObject.selected_regioin,
      preferLanguage: selectedObject && selectedObject.preferred_language,
      door_open_debounce_interval:
        selectedObject && selectedObject.door_open_debounce_interval,
      door_interval_between_two_bins:
        selectedObject && selectedObject.door_interval_between_two_bins,
      boxTypeId: selectedObject && selectedObject.type_id,
      allow_multi_bins_pickup:
        selectedObject && selectedObject.allow_multi_bins_pickup,
      openpath: selectedObject.openpath,
      OpenPathEmailId: selectedObject.openpathemail,
      OpenPathPassword: selectedObject.openpathpassword,
      payroll_deduct: selectedObject && selectedObject.payroll_deduct,
      is_kiosk_log: selectedObject && selectedObject.is_kiosk_log,
      openPathUser: selectedObject && selectedObject.openpathuser,
      selected: [],
      selectedRowId: null
    };
    this.props.retrieveData(filteredObject);
    this.handleContextClose(event);
    this.props.getOpenPathUser(selectedObject.openpathemail, selectedObject.openpathpassword)
  };

  confirmDelete = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    }
    this.setState({ deleteDialogOpen: false });
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + "boxes/" + rowIdToDelete,
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let isoccupy = JSON.parse(result);
        if (isoccupy.res === true || isoccupy.res === "true") {
          this.setState({ loader: false, selected: [] });
          toast.error(this.props.t("Toast.Error.BoxItemRemove"));
        } else {
          this.setState({ loader: false });
          toast.success(this.props.t("Toast.Success.BoxRemove"));
          this.handleContextClose(event);
          const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);

          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          this.handleContextClose(event);
          this.props.params.api.refreshServerSide();
        }
      });
  };

  render() {
    const { classes, t, params } = this.props;
    const { anchorEl, deleteDialogOpen, forDeletion, boxview, boxedit, boxdelete } = this.state;
    const contextOpen = Boolean(anchorEl)

    return (
      <div>
        <Dialog
          open={deleteDialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("Location.AreYouSureToDelete")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("Location.AreYouSureToDeleteBox")}:
              <ul>
                {forDeletion &&
                  forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color="primary"
              className={classes.primaryButton}
            >
              {t("Location.CancelButton")}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color="primary"
              autoFocus
              className={classes.primaryButton}
            >
              {t("Location.DeleteActions")}
            </Button>
          </DialogActions>
        </Dialog>
        <IconButton
          aria-label="More"
          aria-owns={contextOpen ? "long-menu" : null}
          aria-haspopup="true"
          onClick={(event) =>
            this.handleContextClick(event, params.data.id)
          }
        >
          <MoreVertIcon style={{ fontSize: 20 }} />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={contextOpen}
          onClose={this.handleContextClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          }}
        >
          {boxview === true ? (
            <MenuItem
              key="view"
              onClick={this.handleView}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Location.ViewActions")}</ListItemText>
            </MenuItem>
          ) : (
            ""
          )}
          {boxedit === true ? (
            <MenuItem
              key="edit"
              onClick={this.handleEdit}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Location.EditActions")}</ListItemText>
            </MenuItem>
          ) : (
            ""
          )}
          {boxdelete === true ? (
            <MenuItem
              key="delete"
              onClick={this.confirmDelete}
              sx={{ height: "40px" }}
            >
              <ListItemText>{t("Location.DeleteActions")}</ListItemText>
            </MenuItem>
          ) : (
            ""
          )}
        </Menu>
      </div>
    )
  }
}

export default VerticalMenu;


// WEBPACK FOOTER //
// ./src/components/box-list/ActionCellRenderer.js